import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col,
  Glyphicon,
  Button,
  Modal,
  FormControl,
  Accordion,
  Panel
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import request from '../../../utils/Request';
import ErrorAlert from '../../utils/ErrorAlert';

class Archived extends Component {
  constructor(props) {
    super(props);
    const {
      match: { params }
    } = this.props;
    this.state = {
      error: false,
      errorMessage: '',
      property: {},
      documents: [],
      categories: [],
      show: false,
      folder: {
        name: '',
        type: 'property',
        propertyId: params.id
      }
    };

    this.handleClose = this.handleClose.bind(this);
    this.addFolder = this.addFolder.bind(this);

    this.compare = (a, b) => {
      const alpha = a.documentDate;
      const beta = b.documentDate;

      let comparison = 0;
      if (alpha < beta) {
        comparison = 1;
      } else if (alpha > beta) {
        comparison = -1;
      }
      return comparison;
    };

    this.icon = (header) => (
      <div>
        {header}{' '}
        <Glyphicon
          glyph="glyphicon glyphicon-plus"
          style={{ float: 'right' }}
        />
      </div>
    );
  }

  componentDidMount() {
    this.loadProperty();
    this.loadCategories();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.categories !== this.state.categories) this.loadDocuments();
  }

  loadProperty() {
    const {
      match: { params }
    } = this.props;
    request.get(`/strataproperty/${params.id}`).then((property) => {
      this.setState({
        property
      });
    });
  }

  loadCategories() {
    request.get('/StrataDocumentCategories/all').then((categories) => {
      this.setState(
        {
          categories
        },
        () => {}
      );
    });
  }

  loadDocuments() {
    const {
      match: { params }
    } = this.props;
    request
      .get(`/stratadocuments/property/${params.id}?archived=true`)
      .then((documents) => {
        this.setState({ documents });
      })
      .catch(() => {
        this.setState({ error: true, errorMessage: 'Error loading documents' });
      });
  }

  deleteDocument(id) {
    const element = document.getElementById(id);
    if (
      // eslint-disable-next-line no-alert
      window.confirm(
        'Are you sure you want to delete this? This CAN NOT be undone.'
      )
    ) {
      request
        .delete(`/stratadocuments/delete/${id}`)
        .then(() => {
          element.parentNode.removeChild(element);
        })
        .catch(() => {
          this.setState({
            error: true,
            errorMessage: 'Error deleting document'
          });
        });
    }
  }

  restoreDocument(id) {
    const element = document.getElementById(id);
    // eslint-disable-next-line no-alert
    if (window.confirm('The document will be restored')) {
      request
        .put(`/stratadocuments/restore/${id}`)
        .then(() => {
          element.parentNode.removeChild(element);
        })
        .catch(() => {
          this.setState({
            error: true,
            errorMessage: 'Error restoring document'
          });
        });
    }
  }

  showDocument(id) {
    this.props.history.push({
      pathname: `/strataAdmin/document/view/${id}`,
      params: {
        documentFor: 'property'
      }
    });
  }

  getCategory(id) {
    const { categories } = this.state;
    if (categories === undefined || categories.length === 0) {
      return id;
    }

    let category;
    categories.forEach((c) => {
      if (c.id === id) {
        category = c.name;
      }
    });
    return category;
  }

  generatePanels() {
    const { categories, documents } = this.state;

    return categories.map((c) => {
      const catDocs = [];
      documents.forEach((d) => {
        if (c.id === d.strataDocumentCategoryId) {
          catDocs.push({ ...d, title: d.title || 'No File Name' });
        }
      });
      catDocs.sort(this.compare);
      if (catDocs.length > 0) {
        return (
          <div>
            <Grid>
              <Row>
                <Col md={12}>
                  <Accordion>
                    <Panel header={this.icon(c.name)} eventKey="3">
                      {catDocs.map((d) => (
                        <Grid>
                          <Row
                            id={d.id}
                            style={{
                              clear: ' both',
                              overflow: 'hidden',
                              paddingRight: '40px'
                            }}>
                            <Col md={6}>
                              <p style={{ fontSize: '16px' }}>
                                <a
                                  href={`${process.env.REACT_APP_SITE_API}/api/stratadocuments/${d.id}/file`}>
                                  {d.title}
                                </a>
                              </p>
                            </Col>
                            <Col md={6}>
                              <Button
                                bsSize="small"
                                bsStyle="danger"
                                style={{
                                  marginRight: 5,
                                  marginLeft: 5,
                                  float: 'right'
                                }}
                                onClick={() => {
                                  this.deleteDocument(d.id);
                                }}>
                                <Glyphicon glyph="trash" />
                              </Button>
                              <Button
                                bsSize="small"
                                bsStyle="warning"
                                style={{
                                  marginRight: 5,
                                  marginLeft: 5,
                                  float: 'right'
                                }}
                                onClick={() => {
                                  this.restoreDocument(d.id);
                                }}>
                                <Glyphicon glyph="ok" />
                              </Button>
                              <Button
                                bsSize="small"
                                bsStyle="info"
                                style={{
                                  marginRight: 5,
                                  marginLeft: 5,
                                  float: 'right'
                                }}
                                onClick={() => {
                                  this.showDocument(d.id);
                                }}>
                                <Glyphicon glyph="eye-open" />
                              </Button>
                              <Button
                                bsSize="small"
                                bsStyle="success"
                                style={{
                                  marginRight: 5,
                                  marginLeft: 5,
                                  float: 'right'
                                }}
                                href={`${process.env.REACT_APP_SITE_API}/api/stratadocuments/${d.id}/file`}>
                                <Glyphicon glyph="download-alt" />
                              </Button>
                            </Col>
                          </Row>
                          <Row>
                            {this.state.error ? (
                              <ErrorAlert
                                errorMessage={this.state.errorMessage}
                              />
                            ) : null}
                          </Row>
                        </Grid>
                      ))}
                    </Panel>
                  </Accordion>
                </Col>
              </Row>
            </Grid>
          </div>
        );
      }
      return null;
    });
  }

  handleClose() {
    this.setState({ show: false });
  }

  addFolder() {
    request.post('/directory/', this.state.folder).then(() => {
      this.handleClose();
      this.loadDirectories();
    });
  }

  render() {
    return (
      <div>
        <section className="section m-none">
          <Grid>
            <Row>
              <Col md={12}>
                <h3 style={{ marginBottom: 15 }}>
                  Strata Plan {this.state.property.strataPlanNumber} -{' '}
                  {this.state.property.buildingName} ||{' '}
                  {this.state.property.address}
                </h3>
              </Col>
            </Row>
          </Grid>

          {this.generatePanels()}
          <div className="row">
            <div className="col-md-12 text-center">
              <Link
                to={`/strataAdmin/property/${this.state.folder.propertyId}`}
                className="btn btn-outline btn-primary text-uppercase margin-bottom">
                Documents
              </Link>
            </div>
          </div>

          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header>
              <Modal.Title>New Folder</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <FormControl
                name="name"
                type="text"
                placeholder="Folder Name"
                value={this.state.folder.name}
              />
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose}>Close</Button>
              <Button onClick={this.addFolder} bsStyle="primary">
                Add
              </Button>
            </Modal.Footer>
          </Modal>
        </section>
      </div>
    );
  }
}

export default Archived;
